// export default [
//   {
//     title: 'ADMINISTRATOR', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
//     icon: 'far fa-folder',
//     children: [
//       { path: '/admin/dashboard', title: 'Dashboard' },
//       {
//         path: '/admin/company-profiles',
//         title: 'Company Profile',
//         permission: 'view-company-profiles'
//       },
//       {
//         path: '/admin/dealer-profiles',
//         title: 'Dealer Profile',
//         permission: 'view-dealer-profiles'
//       },
//       {
//         path: '/admin/game-settings',
//         title: 'Game Setting',
//         permission: 'view-game-settings'
//       },
//       {
//         path: '/admin/game-prefixes',
//         title: 'Sequence Prefix', // original name is Game Prefix
//         permission: 'view-game-prefixes'
//       },
//       {
//         path: '/admin/draw-settings',
//         title: 'Draw Setting',
//         permission: 'view-draw-settings'
//       },
//       {
//         path: '/admin/game-sets',
//         title: 'Game Set',
//         permission: 'view-game-sets'
//       },
//       {
//         path: '/admin/game-set-results',
//         title: 'Game Set Result',
//         permission: 'view-game-set-results'
//       },
//       {
//         path: '/admin/game-confirm-results',
//         title: 'Game Comfirm Result',
//         permission: 'view-game-comfirm-results'
//       },
//       {
//         path: '/admin/notification-templates',
//         title: 'Notification Template',
//         permission: 'view-notification-templates'
//       },
//       {
//         path: '/admin/content-managements',
//         title: 'Content Management',
//         permission: 'view-content-managements'
//       },
//       {
//         path: '/admin/news',
//         title: 'News',
//         permission: 'view-news'
//       },
//       {
//         path: '/front-covers',
//         title: 'Front Cover',
//         permission: 'view-front-covers'
//       }
//     ]
//   },
//   {
//     title: 'ACCOUNTING', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
//     icon: 'far fa-folder',
//     children: [
//       {
//         path: '/admin/default-commisions',
//         title: 'Default Commission',
//         permission: 'view-default-commisions'
//       },
//       {
//         path: '/admin/deposits',
//         title: 'Dealer Deposit',
//         permission: 'view-deposits'
//       },
//       {
//         path: '/admin/payouts',
//         title: 'Customer Payout',
//         permission: 'view-payouts'
//       },
//       {
//         path: '/admin/claim-payouts',
//         title: 'Payout Claims',
//         permission: 'view-claim-payouts'
//       },
//       {
//         path: '/admin/dealer-withdrawals',
//         title: 'Dealer Withdrawal',
//         permission: 'view-dealer-withdrawals'
//       }
//     ]
//   },
//   {
//     title: 'GAME', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
//     icon: 'far fa-folder',
//     children: [
//       {
//         path: '/admin/game-bettings',
//         title: 'Game Betting',
//         permission: 'view-game-bettings'
//       }
//     ]
//   },
//   {
//     title: 'REPORT',
//     icon: 'far fa-folder',
//     children: [
//       {
//         path: '/admin/winning-reports',
//         title: 'Winning',
//         permission: 'view-winning-reports'
//       },
//       {
//         path: '/admin/claimed-reports',
//         title: 'Claimed',
//         permission: 'view-claimed-reports'
//       },
//       {
//         path: '/admin/unclaimed-reports',
//         title: 'Unclaimed',
//         permission: 'view-unclaimed-reports'
//       },
//       {
//         path: '/admin/dealer-balance-reports',
//         title: 'Dealer Balance',
//         permission: 'view-dealer-balance-reports'
//       },
//       {
//         path: '/admin/dealer-transaction-reports',
//         title: 'Dealer Balance Transaction',
//         permission: 'view-dealer-transaction-reports'
//       },
//       {
//         path: '/admin/liability-reports',
//         title: 'Liability',
//         permission: 'view-liability-reports'
//       },
//       {
//         path: '/admin/ar-list-reports',
//         title: 'AR List',
//         permission: 'view-ar-list-reports'
//       },
//       {
//         path: '/admin/customer-profile-reports',
//         title: 'Customer Profile',
//         permission: 'view-customer-profile-reports'
//       },
//       {
//         path: '/admin/dealer-payout-reports',
//         title: 'Dealer Payout',
//         permission: 'view-dealer-payout-reports'
//       }
//     ]
//   },
//   {
//     title: 'SECURITY',
//     icon: 'far fa-folder',
//     children: [
//       { path: '/admin/roles', title: 'Role', permission: 'view-roles' },
//       { path: '/admin/users', title: 'User', permission: 'view-users' }
//     ]
//   }
// ]

export const office = [
  {
    title: 'ADMINISTRATOR', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'far fa-folder',
    children: [
      { path: '/admin/dashboard', title: 'Dashboard' },
      {
        path: '/admin/company-profiles',
        title: 'Company Profile',
        permission: 'view-company-profiles'
      },
      {
        path: '/admin/game-prefixes',
        title: 'Draw Sequence', //'Sequence Prefix', // original name is Game Prefix
        permission: 'view-game-prefixes'
      },
      {
        path: '/admin/game-settings',
        title: 'Game Setting',
        permission: 'view-game-settings'
      },
      {
        path: '/admin/draw-settings',
        title: 'Draw Setting',
        permission: 'view-draw-settings'
      },
      {
        path: '/admin/game-sets',
        title: 'Game Set',
        permission: 'view-game-sets'
      },
      {
        path: '/admin/game-set-results',
        title: 'Game Result (input)',
        permission: 'view-game-set-results'
      },
      {
        path: '/admin/game-confirm-results',
        title: 'Game Result (confirm)',
        permission: 'view-game-comfirm-results'
      },
    ]

  },
  {
    title: 'DEALER', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'far fa-folder',
    children: [
      {
        path: '/admin/dealer-profiles',
        title: 'Dealer Profile',
        permission: 'view-dealer-profiles'
      },
      {
        path: '/admin/dealer-users',
        title: 'Dealer Users', //'Sequence Prefix', // original name is Game Prefix
        permission: 'view-dealer-users'
      },
      {
        path: '/admin/default-commisions',
        title: 'Default Commission',
        permission: 'view-default-commisions'
      }
    ]

  },
  {
    title: 'CUSTOMER', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'far fa-folder',
    children: [
      {
        path: '/admin/customer-profiles',
        title: 'Customer Profile',
        permission: 'view-customer-profiles'
      }
    ]

  },
  {
    title: 'ACCOUNT', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'far fa-folder',
    children: [
      {
        path: '/admin/deposits',
        title: 'Dealer Deposit',
        permission: 'view-deposits'
      },
      {
        path: '/admin/dealer-withdrawals',
        title: 'Dealer Withdrawal',
        permission: 'view-dealer-withdrawals'
      },
      {
        path: '/admin/claim-payouts',
        title: 'Payout Claims',
        permission: 'view-claim-payouts'
      }
    ]
  },
  {
    title: 'CONTENT SETUP', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'far fa-folder',
    children: [
      {
        path: '/admin/notification-templates',
        title: 'Notification Template',
        permission: 'view-notification-templates'
      },
      {
        path: '/admin/content-managements',
        title: 'Content Management',
        permission: 'view-content-managements'
      },
      {
        path: '/admin/news',
        title: 'News Management',
        permission: 'view-news'
      },
      {
        path: '/front-covers',
        title: 'Front Cover',
        permission: 'view-front-covers'
      }
    ]
  },
  {
    title: 'REPORT', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'far fa-folder',
    children: [
      {
        path: '/admin/winning-reports',
        title: 'Winning Ticket',
        permission: 'view-winning-reports'
      },
      {
        path: '/admin/claimed-reports',
        title: 'Claimed Ticket',
        permission: 'view-claimed-reports'
      },
      {
        path: '/admin/unclaimed-reports',
        title: 'Unclaimed Ticket',
        permission: 'view-unclaimed-reports'
      },
      {
        path: '/admin/liability-reports',
        title: 'Liability',
        permission: 'view-liability-reports'
      },
      {
        path: '/admin/dealer-balance-reports',
        title: 'Dealer Balance',
        permission: 'view-dealer-balance-reports'
      },
      {
        path: '/admin/dealer-transaction-reports',
        title: 'Dealer Balance Transaction',
        permission: 'view-dealer-transaction-reports'
      },
      {
        path: '/admin/dealer-payout-reports',
        title: 'Dealer Payout Transaction',
        permission: 'view-dealer-payout-reports'
      },
      {
        path: '/admin/ar-list-reports',
        title: 'AR List',
        permission: 'view-ar-list-reports'
      },
      {
        path: '/admin/customer-profile-reports',
        title: 'Customer List',
        permission: 'view-customer-profile-reports'
      },
    ]
  },
  {
    title: 'SECURITY',
    icon: 'far fa-folder',
    children: [
      { path: '/admin/roles', title: 'Role', permission: 'view-roles' },
      { path: '/admin/users', title: 'User', permission: 'view-users' }
    ]
  }
];

export const superDealer = [
    {
      path: '/admin/game-bettings',
      title: 'BET',
      icon: 'fas fa-ticket-alt',
      permission: 'view-game-bettings'
    },
    {
      title: 'DEALER', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
      icon: 'far fa-folder',
      children: [
        {
          path: '/admin/dealer-profiles',
          title: 'Dealer Profile',
          permission: 'view-dealer-profiles'
        },
        {
          path: '/admin/dealer-users',
          title: 'Dealer Users', //'Sequence Prefix', // original name is Game Prefix
          permission: 'view-dealer-profiles'
        },
      ]
    },
    {
      title: 'ACCOUNT', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
      icon: 'far fa-folder',
      children: [
        {
          path: '/admin/deposits',
          title: 'Dealer Deposit',
          permission: 'view-deposits'
        },
        {
          path: '/admin/customer-deposits',
          title: 'Customer Deposit',
          permission: 'view-deposits'
        },
        {
          path: '/admin/payouts',
          title: 'Ticket Payout', //'Customer Payout',
          permission: 'view-payouts'
        },
      ]
    },
    {
      title: 'REPORT', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
      icon: 'far fa-folder',
      children: [
        {
          path: '/admin/dealer-balance-reports',
          title: 'Dealer Balance',
          permission: 'view-dealer-balance-reports'
        },
        {
          path: '/admin/dealer-transaction-reports',
          title: 'Dealer Balance Transaction',
          permission: 'view-dealer-transaction-reports'
        },
        {
          path: '/admin/dealer-payout-reports',
          title: 'Dealer Payout Transaction',
          permission: 'view-dealer-payout-reports'
        },
      ]
    }
];

export default { office, superDealer }
